import { NgModule } from '@angular/core';
import { RecaptchaLoaderService } from './recaptcha-loader.service';
import { RecaptchaComponent } from './recaptcha.component';

@NgModule({
  declarations: [RecaptchaComponent],
  exports: [RecaptchaComponent],
  providers: [RecaptchaLoaderService]
})
export class RecaptchaModule { }
